import { type CMState } from '@/hooks/useChangeManagements';

/** Badge background/text classes per CM state (matches CMDetails STATE_STYLE). */
export const CM_STATE_STYLE: Record<CMState, string> = {
  draft: 'bg-muted text-muted-foreground',
  waiting_approval: 'bg-sev-3/20 text-foreground',
  approved: 'bg-sev-5/15 text-sev-5',
  rejected: 'bg-sev-1/15 text-sev-1',
  in_progress: 'bg-brand-soft text-brand',
  paused: 'bg-sev-3/30 text-foreground',
  verification: 'bg-sev-5/20 text-sev-5',
  completed: 'bg-sev-4/15 text-sev-4',
  cancelled: 'bg-muted text-muted-foreground',
  partially_completed: 'bg-sev-3/20 text-foreground',
};

/** Solid dot color per CM state — for compact calendar/agenda chips. */
export const CM_STATE_DOT: Record<CMState, string> = {
  draft: 'bg-muted-foreground',
  waiting_approval: 'bg-sev-3',
  approved: 'bg-sev-5',
  rejected: 'bg-sev-1',
  in_progress: 'bg-brand',
  paused: 'bg-sev-3',
  verification: 'bg-sev-5',
  completed: 'bg-sev-4',
  cancelled: 'bg-muted-foreground',
  partially_completed: 'bg-sev-3',
};

/** Human label for a CM state ("in_progress" → "In progress"). */
export function cmStateLabel(state: CMState): string {
  const s = state.replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** States that are running right now (executing/awaiting verification). */
export const CM_RUNNING_STATES: CMState[] = ['in_progress', 'paused', 'verification'];

/** States that represent committed, not-yet-started scheduled work. */
export const CM_SCHEDULED_STATES: CMState[] = ['approved', 'waiting_approval'];
